<div class="w-100 h-100 d-flex flex-column overflow-hidden">
  <h5>Add New Aggregate File</h5>
  <hr />
  <form (submit)="onSave()" [formGroup]="aggregateForm">
    <div class="d-flex flex-column">
      <mat-form-field>
        <mat-label>Aggregate Filename</mat-label>
        <input formControlName="aggregateFileName" matInput />
      </mat-form-field>
      @if (error) {
        <div class="error-text py-2">
          {{ error }}
        </div>
      }
      <div class="d-flex flex-grow-1 justify-content-end align-items-end gap-2">
        @if (showSpinner) {
          <mat-spinner [diameter]="25"></mat-spinner>
        }
        <button
          type="button"
          class="ra-blue-btn mat-mdc-raised-button"
          (click)="closeDialog()"
        >
          Cancel
        </button>
        <button
          type="submit"
          class="ra-blue-btn mat-mdc-raised-button"
          [disabled]="!aggregateForm.valid"
        >
          Save
        </button>
      </div>
    </div>
  </form>
</div>
